import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch } from "react-redux";
import {
  startLoading,
  stopLoading,
} from "../../../redux/reducers/loadingSlice";
import { signIn } from "../../../redux/reducers/authSlice";
import { loginFromValidator } from "../../../services/validatior/formValidator/authValidator";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import SocialSignIn from "./SocialSignIn";

const Login = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rememberMe, setRememberMe] = useState(false);
  const location = useLocation()

  const [isPwdShown, setIsPwdShown] = useState(true);
  const loginFromik = useFormik({
    initialValues: loginFromValidator.initialValues,
    validationSchema: loginFromValidator.validationSchema,
    onSubmit: (values) => {

      dispatch(
        signIn({ values: values, navigate: navigate, gotoLogin: true, gotoJobBoard: location?.state?.gotoJobBoard, dispatch: dispatch, rememberMe })
      );


    }
  })
  const callLogin = () => {

  };

  const gotoForget = () => {
    navigate("/forgot-password");
  };

  const gotoSignup = () => {
    navigate("/signup");
  };


  return (
    <>
      <div className="authentication-wrapper authentication-cover auth-login authentication-bg">
        <div className="authentication-inner row">
          <div className="d-none d-lg-flex col-lg-7 p-0">
            <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
              <img
                className="img-fluid auth-illustration"
                src="/assets/images/auth-login-illustration-light.png"
                alt=""
              />
              {/* <img src="/assets/images/bg-shape-image-light.png" alt="" /> */}
            </div>
          </div>

          <div className="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              {/* Logo */}
              <div className="app-brand mb-4">
                <img src="/assets/images/OHC-Logo.png" alt="" />
              </div>
              <p className="mb-4">Please sign-in to your account</p>
              <form onSubmit={loginFromik.handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id='email' name='email'
                    value={loginFromik?.values.email}
                    onChange={loginFromik.handleChange}
                    placeholder="Enter your email"
                  />
                  <p className='form-error-message'>{loginFromik.touched.email &&
                    loginFromik.errors.email}</p>
                </div>
                <div className="mb-3 form-password-toggle">
                  <div className="position-relative">
                    <label className="form-label" htmlFor="password">
                      Password
                    </label>
                    <div className="input-group input-group-merge ">
                      <input
                        type={isPwdShown ? "password" : "text"}
                        id="password"
                        className="form-control"
                        name='password'
                        value={loginFromik?.values.password}
                        onChange={loginFromik.handleChange}
                        placeholder=""
                        aria-describedby="password"
                      />

                      <span className="input-group-text cursor-pointer">
                        <FontAwesomeIcon
                          icon={
                            isPwdShown
                              ? icon({ name: "eye-slash" })
                              : icon({ name: "eye" })
                          }
                          onClick={() => setIsPwdShown(!isPwdShown)}
                        />
                      </span>

                    </div>
                    <p
                      className="for-get colour-red cursor-pointer"
                      onClick={gotoForget}
                    >
                      Forget Password ?
                    </p>
                  </div>
                  <p className='form-error-message'>{loginFromik.touched.password &&
                    loginFromik.errors.password}</p>
                </div>

                <div className="mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="terms-conditions"
                      name="terms"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="terms-conditions"
                    >
                      Remember Me
                    </label>
                  </div>
                </div>
                <button type="submit" className="btn w-100 mb-3">Log in</button>
              </form>
              <p className="text-center">
                <span>New on our platform? </span>

                <span
                  className="colour-red cursor-pointer"
                  onClick={gotoSignup}
                >
                  Create an account
                </span>
              </p>
              {/* <div className="divider my-4 text-center">
                <div className="divider-text w-100">or</div>
              </div> */}
              {/* {
                process.env.REACT_APP_ENVIROMENT !== 'production' &&
                <SocialSignIn />
              } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
